<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto d-flex flex-column justify-center align-center" v-if="!$auth.user.can_send_tickets">
        <div class="text-center">
            <v-img src="@/assets/img/force-satisfaction.svg" aspect-ratio="16/9" max-width="600" class="mx-auto"></v-img>
            <p class="text-grey-darken-1 text-meta my-4">شما دارای {{$auth.user.without_satisfaction_tickets}} تیکت بسته شده بدون شرکت در نظرسنجی آنها هستید و به همین دلیل امکان ثبت تیکت جدید هم اکنون برای شما وجود ندارد.<br>از آنجایی که نظر شما در خصوص نحوه رسیدگی به تیکت ها برای ما بسیار ارزشمند است، از شما خواهشمندیم با شرکت در نظرسنجی پایان تیکت ها، ما را در ارائه خدمات بهتر یاری نمایید.</p>
            <v-btn @click="$router.push({path: '/tickets', query: {'satisfactions': [0], 'ticket_statuses': [4], own_tickets: 1} })" color="primary" class="mt-1">مشاهده تیکت های بدون نظر سنجی</v-btn>
        </div>
    </div>
    <div v-else class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-form @submit.prevent="$refs.ticketForm.isValid && sendTicket()" ref="ticketForm">
            <v-row justify="space-between">
                <v-col xl="6" lg="7" md="8" cols="12">
                    <custom-divider v-if="$auth.user.employee" class="mb-3" label="گیرنده تیکت"></custom-divider>
                    <v-row v-if="$auth.user.employee" dense>
                        <v-col md="" sm="6" cols="12" v-if="!$auth.user.full_admin">
                            <v-autocomplete
                                :rules="$validation('required')"
                                :items="$auth.user.from_departments"
                                item-title="name"
                                item-value="id"
                                label="* دپارتمان فرستنده"
                                no-data-text="موردی پیدا نشد!"
                                v-model="form.from_department"
                            ></v-autocomplete>
                        </v-col>
                        <v-col md="" sm="6" cols="12" v-else>
                            <v-autocomplete
                                :rules="$validation('required')"
                                :items="$system.branches.filter(x => x.status)"
                                item-title="name"
                                item-value="id"
                                label="* شعبه گیرنده"
                                no-data-text="موردی پیدا نشد!"
                                v-model="form.branch_id"
                            ></v-autocomplete>
                        </v-col>
                        <v-col md="" sm="6" cols="12">
                            <v-autocomplete
                                :rules="$validation('required')"
                                :items="$auth.user.to_departments"
                                item-title="name"
                                item-value="id"
                                label="* دپارتمان/گروه گیرنده"
                                no-data-text="موردی پیدا نشد!"
                                v-model="form.to_department"
                            ></v-autocomplete>
                        </v-col>
                        <v-col md="" cols="12" v-if="$rbac.can('send ticket to customers')">
                            <v-autocomplete
                                :disabled="(!!$auth.user.full_admin && !form.branch_id) || !form.to_department || form.to_department !== $system.customers_department.id"
                                :items="$auth.user.full_admin ? $system.organizations.filter(x => x.branch_id == form.branch_id) : $system.organizations"
                                item-title="name"
                                item-value="id"
                                label="سازمان مشتریان"
                                no-data-text="موردی پیدا نشد!"
                                clearable
                                v-model="organization_id"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row v-if="$auth.user.employee" dense>
                        <v-col>
                            <v-autocomplete
                                :disabled="!form.to_department || (!!$auth.user.full_admin && !form.branch_id)"
                                :rules="$validation('required')"
                                :items="users"
                                hide-no-data
                                :loading="inputLoading"
                                @update:search="userChange"
                                v-model="form.to_users"
                                hide-selected
                                :chips="$system.license.features.ticket_send_multiple"
                                :closable-chips="$system.license.features.ticket_send_multiple"
                                :multiple="$system.license.features.ticket_send_multiple"
                                item-title="name"
                                item-value="id"
                                :placeholder="$system.customers_department.id == form.to_department ? 'حداقل 3 حرف جستجو کنید' : (!users.length ? 'موردی پیدا نشد' : '')"
                                label="* کاربر گیرنده تیکت"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="auto" v-if="$system.license.features.ticket_mention">
                            <v-badge :content="shares.length" :model-value="!!shares.length">
                                <v-btn class="text-secondary" variant="tonal" v-tooltip="'چنانچه نیاز دارید علاوه بر گیرنده اصلی تیکت افراد دیگری نیز به این تیکت دسترسی داشته باشند می‌توانید آن‌ها را به عنوان مشارکت کننده اضافه کنید'" @click="$refs.ticketShares.shareDialog = true" :disabled="$auth.user.full_admin ? !form.branch_id : false">
                                    <v-icon icon="icon-at" class="me-2"></v-icon>اشتراک گذاری
                                </v-btn>
                            </v-badge>
                        </v-col>
                    </v-row>
                    <v-autocomplete
                        :rules="$validation('required')"
                        :items="$auth.user.to_departments"
                        v-if="!$auth.user.employee"
                        item-title="name"
                        item-value="id"
                        label="* دپارتمان/گروه گیرنده"
                        no-data-text="موردی پیدا نشد!"
                        v-model="form.to_department"
                    ></v-autocomplete>
                    <custom-divider v-if="$auth.user.employee" class="mb-3" label="جزئیات تیکت"></custom-divider>
                    <v-autocomplete
                        :rules="$validation('required:' + ($auth.user.employee ? 0 : 1))"
                        :items="serviceList"
                        :disabled="!form.to_department"
                        v-if="serviceList.length"
                        item-title="name"
                        item-value="id"
                        :label="(($auth.user.employee ? '' : '* ')) + 'محصول/سرویس'"
                        no-data-text="موردی پیدا نشد!"
                        v-model="form.service_id"
                    ></v-autocomplete>
                    <v-autocomplete
                        :rules="$validation('required')"
                        :items="[...categories,{name:'سایر',id:'other',status:true}].filter(x=>x.status)"
                        :disabled="!form.to_department"
                        v-if="categories.length"
                        item-title="name"
                        item-value="id"
                        label="* دسته بندی موضوعی"
                        no-data-text="موردی پیدا نشد!"
                        v-model="form.ticket_category_id"
                    ></v-autocomplete>
                    <v-slide-y-transition>
                        <div class="pa-2 mb-7 rounded" v-if="form.ticket_category_id && form.ticket_category_id != 'other' && categories.find(x => x.id == form.ticket_category_id).description" style="background-color: #eef7ff; border: 1px solid #2877dc !important">
                            <p class="text-grey-darken-3 text-small"><v-icon class="me-1">info</v-icon>{{ categories.find(x => x.id == form.ticket_category_id).description }}</p>
                        </div>
                    </v-slide-y-transition>
                    <v-select
                        :rules="$validation('required')"
                        label="* میزان اهمیت"
                        no-data-text="موردی پیدا نشد!"
                        v-model="form.importance"
                        item-title="name"
                        item-value="id"
                        :items="$system.importances"
                        v-if="!$auth.user.employee"
                    ></v-select>
                    <v-text-field
                        :rules="$validation('required')"
                        label="* عنوان"
                        v-model="form.title"
                    ></v-text-field>
                    <custom-fields-form :items="customFields" v-model="form.custom_fields" v-if="$system.license.features.custom_field" transition></custom-fields-form>
                    <ckeditor
                        ref="ticketTexteditor"
                        v-model="form.content"
                    ></ckeditor>
                    <div class="d-flex justify-end bg-blue-grey-lighten-5 border border-t-0 rounded-b pa-1">
                        <v-btn v-tooltip="'متن‌های آماده'" size="small" class="mx-1" v-if="$system.license.features.ticket_canned_message && $auth.user.employee" color="primary" @click="ticketTemplateDrawer = true" icon="icon-templateticket" variant="text"></v-btn>
                        <v-btn v-tooltip="'پایگاه دانش'" v-if="$auth.user.employee && $system.license.features.kb_core && $system.systemSettings.knowledge_base_status" size="small" class="mx-1" icon="icon-kb" variant="text" color="primary" @click="$refs.ticketKnowledgebase.dialog = true"></v-btn>
                        <v-btn v-tooltip="'درج امضاء'" size="small" class="mx-1" icon="icon-signature" variant="text" color="primary" v-if="$auth.user.employee" @click="signatureDrawer = true"></v-btn>
                        <v-badge :model-value="$refs.files && !!$refs.files.getFiles()?.length" :content="$refs.files ? $refs.files.getFiles().length : 0" location="top right">
                            <v-btn size="small" class="mx-1" icon variant="text" color="primary" v-tooltip="'فایل‌ پیوست'">
                                <v-icon @click="attachmentDialog = true" color="primary">icon-attachticket</v-icon>
                            </v-btn>
                        </v-badge>
                    </div>
                    <v-row class="mt-4" dense>
                        <v-col :sm="$auth.user.employee ? 6 : 12" cols="12" v-if="$auth.user.employee">
                            <v-select
                                :rules="$validation('required')"
                                label="* میزان اهمیت"
                                no-data-text="موردی پیدا نشد!"
                                v-model="form.importance"
                                item-title="name"
                                item-value="id"
                                :items="$system.importances"
                            ></v-select>
                        </v-col>
                        <v-col sm="6" cols="12" v-if="$auth.user.employee">
                            <v-select
                                :rules="$validation('required')"
                                label="* وضعیت"
                                no-data-text="موردی پیدا نشد!"
                                v-model="form.ticket_status"
                                item-title="name"
                                item-value="id"
                                :items="$system.ticketStatuses.filter(x => ![2,3].includes(x.id))"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <div class="mt-4">
                        <v-btn type="submit" color="success" :loading="loading">ارسال تیکت</v-btn>
                        <v-btn class="ms-3" variant="text" color="error" @click="$router.push({path: '/tickets'});" :disabled="loading">بازگشت</v-btn>
                    </div>
                </v-col>
                <v-col cols="4" class="d-none d-md-block" v-if="$system.license.features.kb_core && $system.systemSettings.knowledge_base_status">
                    <v-fade-transition>
                        <div v-if="this.form.ticket_category_id && this.articles.length" class="cursor-pointer">
                            <h4 class="font-weight-bold">مرتبط ترین مقاله های پایگاه دانش</h4>
                            <p class="text-grey-darken-1 mt-2 mb-5 text-small">پیش از ثبت تیکت، مطالعه مقاله های زیر را به  شما پیشنهاد می کنیم. ممکن است محتوای این موارد پاسخ سوال فعلی شما باشد.</p>
                            <v-row v-for="item in articles" :key="item.id" @click="openArticle(item)" class="bg-grey-lighten-4 mb-4 mx-0 rounded" style="border: 1px solid #E6E6E6 !important" align="center">
                                <v-col class="pe-0" cols="auto"><v-icon size="20">icon-kb</v-icon></v-col>
                                <v-col><p class="text-grey-darken-2 mb-0 text-meta">{{ item.name }}</p></v-col>
                            </v-row>
                        </div>
                    </v-fade-transition>
                </v-col>
            </v-row>
        </v-form>
        <ticketShare @sendTicket="(params)=>{shares = [...params.shares]; $refs.ticketShares.shareDialog = false}" noHistory ref="ticketShares"></ticketShare>
        <v-dialog persistent v-model="attachmentDialog" width="500" eager>
            <v-card tile>
                <v-toolbar color="white">
                    <v-toolbar-title class="text-primary">آپلود فایل‌های پیوست</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="attachmentDialog = false" icon>
                        <v-icon color="primary" size="23">close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-divider></v-divider>
                <div class="px-6 py-4 text-grey-darken-2">
                    <p class="text-small text-grey-darken-3 mb-0">فرمت های مجاز فایل های پیوست: {{$system.systemSettings.attachments_allowed_types.map(x => x.toUpperCase()).join(', ')}}</p>
                    <p class="text-small text-grey-darken-3 mb-0 mt-n1">حداکثر حجم تمام فایل های پیوست: {{$system.systemSettings.attachments_maximum_size}}</p>
                    <p class="text-small text-grey-darken-3 mb-0 mt-n1">حداکثر تعداد فایل پیوست: 5 مورد</p>
                    <file-input
                        class="mt-3"
                        :style="{backgroundColor: '#e7e7e7', borderRadius: '4px'}"
                        :text="`<p class='text-meta font-weight-bold text-center mb-0 py-7'>آپلود فایل‌های پیوست</p>`"
                        :types="$system.systemSettings.attachments_allowed_types"
                        :mimeTypes="$system.systemSettings.attachments_allowed_types.map(x => $system.mimeTypes[x]).flat()"
                        :size="parseInt($system.systemSettings.attachments_maximum_size) * ($system.systemSettings.attachments_maximum_size.indexOf('MB') != -1 ? 1048576 : 1024)"
                        :maxFiles="5"
                        type="file"
                        ref="files"
                    ></file-input>
                </div>
                <v-card-actions class="pb-4 mx-2">
                    <v-btn @click="attachmentDialog = false" block variant="flat" color="success" >بستن و ادامه</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="ticketTemplateDrawer" v-if="$auth.user.employee && $system.license.features.ticket_canned_message" width="700">
            <v-card tile>
                <v-toolbar color="white">
                    <v-toolbar-title class="text-primary">متن‌های آماده</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="ticketTemplateDrawer = false" icon>
                        <v-icon color="primary" size="23">close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-divider></v-divider>
                <div class="px-6 mt-5 text-grey-darken-2 position-relative" style="min-height: 350px;max-height: 400px;overflow-y: auto;scrollbar-width: thin;">
                    <v-text-field
                        append-inner-icon="search"
                        class="bg-white"
                        label="جستجو"
                        style="position: sticky; top: 0; z-index: 300"
                        v-model="ticketTemplateSearchbox"
                    ></v-text-field>
                    <v-row align="center" class="mx-0 rounded my-1 bg-grey-lighten-4" justify="space-between" v-for="(item, index) in ticketTemplateList.filter((x) => !ticketTemplateSearchbox || x.name.includes(ticketTemplateSearchbox))" :key="index">
                        <v-col @click="item.showBody = !item.showBody">
                            <p class="text-grey-darken-2 text-meta user-select-none cursor-pointer">
                                <v-icon color="grey-darken-2" size="24">{{item.showBody? "arrow_drop_up": "arrow_drop_down"}}</v-icon>{{ item.name }}
                            </p>
                        </v-col>
                        <v-col class cols="auto">
                            <v-btn @click="setTicketTemplate(item.body)" variant="tonal" color="secondary">
                                <v-icon size="18">add</v-icon>
                                <p class="ms-1 text-small">انتخاب</p>
                            </v-btn>
                        </v-col>
                        <v-col class="bg-grey-lighten-2 rounded pa-0" cols="12" style="height: 1px" v-if="item.showBody"></v-col>
                        <v-expand-transition>
                            <v-col class="pa-0" cols="12" v-if="item.showBody">
                                <p class="text-grey-darken-2 text-small px-3 pt-2" v-sanitize="item.body" ></p>
                            </v-col>
                        </v-expand-transition>
                    </v-row>
                </div>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="signatureDrawer" v-if="$auth.user.employee" width="700">
            <v-card tile>
                <v-toolbar color="white">
                    <v-toolbar-title class="text-primary">امضا ها</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="signatureDrawer = false" icon>
                        <v-icon color="primary" size="23">close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-divider></v-divider>
                <div class="px-6 mt-5 text-grey-darken-2 position-relative" style="min-height: 350px;max-height: 400px;overflow-y: auto;scrollbar-width: thin;">
                    <v-row align="center" class="mx-0 rounded bg-grey-lighten-4 my-1" justify="space-between" v-for="(item, index) in signatureList" :key="index">
                        <v-col @click="item.showBody = !item.showBody">
                            <p class="mb-0 text-grey-darken-2 text-meta user-select-none cursor-pointer">
                                <v-icon color="grey-darken-2" size="24">{{item.showBody? "arrow_drop_up": "arrow_drop_down"}}</v-icon>{{ item.name }}
                            </p>
                        </v-col>
                        <v-col class cols="auto">
                            <v-btn @click="setTicketTemplate(item.body)" color="secondary" variant="tonal">
                                <v-icon size="18">add</v-icon>
                                <p class="mb-0 ms-1 text-small">انتخاب</p>
                            </v-btn>
                        </v-col>
                        <v-col class="bg-grey-lighten-2 rounded pa-0" cols="12" style="height: 1px" v-if="item.showBody"></v-col>
                        <v-expand-transition>
                            <v-col class="pa-0" cols="12" v-if="item.showBody">
                                <p class="text-grey-darken-2 text-small px-3 pt-2" v-sanitize="item.body"></p>
                            </v-col>
                        </v-expand-transition>
                    </v-row>
                </div>
            </v-card>
        </v-dialog>
        <ticket-knowledgebase @paste="setTicketTemplate" ref="ticketKnowledgebase"></ticket-knowledgebase>
    </div>
</template>
<script>
export default {
    title: "ایجاد",
    validate(context) {
        return !context.auth.user.expired;
    },
    data() {
        return {
            loading: false,
            inputLoading: false,
            shares: [],
            articles: [],
            signatureDrawer: false,
            signatureList: [],
            ticketTemplateList: [],
            ticketTemplateSearchbox: null,
            ticketTemplateDrawer: false,
            selectedUsers: [],
            users: [],
            serviceList: [],
            categories: [],
            customFields: [],
            ticketForm: false,
            form: {
                branch_id: null,
                from_department: this.$auth.user.from_departments.length == 1 ? this.$auth.user.from_departments[0].id : null,
                to_department: null,
                to_users: null,
                ticket_category_id: null,
                title: null,
                content: '',
                importance: 1,
                service_id: null,
                ticket_status: 0,
                custom_fields: []
            },
            organization_id:null,
            attachmentDialog: false,
        };
    },
    methods: {
        openArticle(item) {
            window.open(`/kb/articles/${item.id}/${item.slug}`, '_blank');
        },
        setCustomFields() {
            if (this.$system.license.features.custom_field) {
                let ticketForm = this.$system.ticketForms.find(x => x.status &&
                    x.form.custom_fields.length &&
                    this.form.to_department &&
                    x.department_id == this.form.to_department &&
                    (!x.services.length || (this.form.service_id && x.services.find(y => y.id == this.form.service_id))) &&
                    (!x.ticket_categories.length || (this.form.ticket_category_id && x.ticket_categories.find(y => y.id == this.form.ticket_category_id))) &&
                    (!x.other_ticket_category || this.form.ticket_category_id == 'other')
                );
                if (ticketForm && (!this.ticketForm || ticketForm.id !== this.ticketForm.id))
                    this.customFields = ticketForm.form.custom_fields;
                else if (!ticketForm && this.ticketForm)
                    this.customFields = [];
                this.ticketForm = ticketForm;
            }
        },
        organizationChanged() {
            this.form.to_users = null;
            this.users = [];
            if (this.organization_id && this.$system.organizations.find(x => x.id == this.organization_id)?.customer_informations_count < 20)
                this.userChange('organizationChanged');
            if (this.$refs.ticketForm)
                this.$refs.ticketForm.resetValidation();
        },
        ticketCategoryChanged() {
            this.articles = [];
            if(this.form.ticket_category_id != 'other' && this.$system.license.features.kb_core && this.$system.systemSettings.knowledge_base_status)
                this.$kbArticleList({ticket_category_id: this.form.ticket_category_id}).then(res => {
                    if (res && res.status == "OK")
                        this.articles = res.data;
                })
            this.setCustomFields();
        },
        serviceChanged() {
            this.setCustomFields();
        },
        branchChanged() {
            if (this.$auth.user.full_admin) {
                this.organization_id = null;
                this.form.to_users = null;
                let users = this.form.to_department && this.$system.customers_department.id != this.form.to_department ? this.$auth.user.to_departments.find(x => x.id == this.form.to_department).users : [];
                this.users = JSON.parse(JSON.stringify(users)).map(x => {x.name = x.name + (x.supervisor ? ' (سرپرست)' : ''); delete x.supervisor; return x;})
                this.users = this.users.filter((x) => x.branch_id == this.form.branch_id || x.branch_id == -1);
                if (this.$system.license.features.ticket_mention){
                    this.$refs.ticketShares.clearAll();
                    this.shares = [];
                    this.$refs.ticketShares.getAllUsersOnly(this.form.branch_id);
                }
                if (this.$refs.ticketForm)
                    this.$refs.ticketForm.resetValidation();
            }
        },
        toDepartmentChanged() {
            this.form.to_users = null;
            this.form.ticket_category_id = null;
            this.form.service_id = null;
            let users = this.$auth.user.employee && this.$system.customers_department.id != this.form.to_department && (!this.$auth.user.full_admin || this.form.branch_id) ? this.$auth.user.to_departments.find(x => x.id == this.form.to_department).users : [];
            this.users = JSON.parse(JSON.stringify(users)).map(x => {x.name = x.name + (x.supervisor ? ' (سرپرست)' : ''); delete x.supervisor; return x;})
            this.users = this.$auth.user.full_admin ? this.users.filter((x) => x.branch_id == this.form.branch_id || x.branch_id == -1) : this.users;
            this.serviceList = this.$auth.user.to_departments.find(x => x.id == this.form.to_department)?.services ?? [];
            this.categories = this.$system.ticketCategories.filter((x) => x.department_id === this.form.to_department);
            if (this.serviceList.length == 1)
                this.form.service_id = this.serviceList[0].id;
            if (this.categories.length == 0)
                this.form.ticket_category_id = 'other';
            this.setCustomFields();
            if (this.$refs.ticketForm)
                this.$refs.ticketForm.resetValidation();
        },
        toUserChanged(to, from) {
            if (this.form.to_department == this.$system.customers_department.id && (!this.$system.license.features.ticket_send_multiple || to?.length > from?.length)) {
                let user = this.users.find(x => x.id == this.$system.license.features.ticket_send_multiple ? to.at(-1) : to);
                if (user && user.expired)
                    this.$toast.warning('حساب کاربری ' + user.name + ' غیر فعال یا منقضی شده است');
            }
        },
        userChange(val) {
            if (!this.inputLoading && this.$system.customers_department.id == this.form.to_department && this.$rbac.can("send ticket to customers") && val && val.length > 2) {
                this.inputLoading = true;
                let params = {
                    employee: 0,
                    fast: 1,
                    ticket_keyword: val !== 'organizationChanged' ? val : null,
                };
                if (this.organization_id)
                    params['organizations'] = [this.organization_id];
                if (this.$auth.user.full_admin)
                    params["branch_id"] = this.form.branch_id;
                this.$userList(params).then((res) => {
                    if (res && res.status == "OK") {
                        let newUsers = res.data.map(x => {x.name = x.customer_information.position ? `${x.name} (${x.customer_information.position})` : (x.name ?? '-'); delete x.customer_information; return x;});
                        let oldUsers = this.$system.license.features.ticket_send_multiple ? this.users.filter(x => this.form.to_users.includes(x.id) && !newUsers.some(y => y.id == x.id)) : this.users.filter(x => this.form.to_users == x.id && !newUsers.some(y => y.id == x.id));
                        this.users = [...oldUsers, ...newUsers];
                    }
                }).finally(() => this.inputLoading = false);
            }
        },
        setTicketTemplate(content) {
            this.$refs.ticketTexteditor.insertContent(content);
            this.ticketTemplateDrawer = false;
            this.signatureDrawer = false;
            this.$refs.ticketKnowledgebase.dialog = false;
        },
        sendTicket() {
            if (!this.form.content.replace(/<[^>]*>?/gm, ""))
                this.$toast.error("تکمیل محتوای تیکت الزامی است");
            else {
                this.loading = true;
                let form = { ...this.form };
                if(!this.$system.license.features.ticket_send_multiple)
                    form.to_users = [form.to_users];
                if (this.$system.license.features.custom_field)
                    form.custom_fields = form.custom_fields.filter(x => x.value !== '' && x.value !== null);
                if (!this.$system.license.features.custom_field || !form.custom_fields.length)
                    delete form.custom_fields;
                if (this.$auth.user.employee) {
                    if (this.$system.license.features.ticket_mention && this.shares && this.shares.length)
                        form.shares = JSON.parse(JSON.stringify(this.shares)).map((el) => {return {user_id: el.user_id, editable: el.editable}});
                } else {
                    form.from_department = this.$system.customers_department.id;
                    delete form.to_users;
                }
                if(!form.service_id)
                    delete form.service_id;
                if (form.ticket_category_id === "other")
                    form.ticket_category_id = null;
                if (this.$refs.files) {
                    let attachments = this.$refs.files.getValidFiles();
                    if(attachments.length)
                        form.attachments = attachments.map(x => x.file);
                }
                this.$ticketStore(this.$object.toFormData(form)).then((res) => {
                    if (res && res.status == "CREATED") {
                        if(Object.hasOwn(res.data, 'in_shift') && !res.data.in_shift)
                            this.$toast.warning(res.message);
                        else
                            this.$toast.success(res.message);
                        this.$router.push({path: '/tickets' });
                    }
                }).finally(()=>{this.loading = false;});
            }
        },
        async checkCustomerIdsFromQuery() {
            if (this.$rbac.can("send ticket to customers") && Object.hasOwn(this.$route.query, "customer_ids") && (!this.$auth.user.full_admin || Object.hasOwn(this.$route.query, "branch_id"))) {
                let ids = this.$route.query.customer_ids.includes(',') ? this.$route.query.customer_ids.split(",") : [this.$route.query.customer_ids];
                let params = {
                    ids: ids,
                    fast: 1,
                    perPage: ids.length,
                    employee: 0,
                };
                if(this.$auth.user.full_admin)
                    params['branch_id'] = this.form.branch_id = parseInt(this.$route.query.branch_id);
                this.form.to_department = this.$system.customers_department.id;
                await this.$userList(params).then((res) => {
                    if (res && res.status == "OK" && res.data.length) {
                        this.users = res.data;
                        if(this.$system.license.features.ticket_send_multiple)
                            this.form.to_users = res.data.map((x) => x.id);
                        else
                            this.form.to_users = res.data[0].id;
                    }
                });
            }
        },
    },
    watch: {
        attachmentDialog() {
            setTimeout(() => {
                this.attachmentDialog ? this.$refs.files.activePasteEvent() : this.$refs.files.deactivePasteEvent();
            }, 100);
        },
        "form.branch_id"() {
            this.branchChanged();
        },
        "form.to_department"() {
            this.toDepartmentChanged();
        },
        "form.ticket_category_id"() {
            this.ticketCategoryChanged();
        },
        "form.service_id"() {
            this.serviceChanged();
        },
        "form.to_users"(to, from) {
            this.toUserChanged(to, from);
        },
        organization_id() {
            this.organizationChanged();
        }
    },
    mounted() {
        if (!this.$auth.user.can_send_tickets)
            return;
        this.$nextTick(async () => {
            this.$loading.start();
            if(this.$auth.user.employee) {
                this.signatureList = this.$auth.user.full_admin || this.$auth.user.branch_admin
                    ? [{
                            'name': this.$auth.user.full_admin ? 'مدیر ارشد' : 'سرپرست شعبه',
                            'body': this.$auth.user.manager_information && Object.hasOwn(this.$auth.user.manager_information, 'signature') ? this.$auth.user.manager_information.signature : null,
                            'showBody': false
                        }]
                    : this.$auth.user.positions.map(x => {
                        return {
                            'name': this.$system.departments.find((el) => el.id == x.department_id).name,
                            'body': Object.hasOwn(x, 'signature') ? x.signature : null,
                            'showBody': false
                        }
                    });
                if(!this.$auth.user.full_admin && this.$system.license.features.ticket_mention)
                    this.$refs.ticketShares.getAllUsersOnly();
                if(this.$system.license.features.ticket_canned_message)
                    this.ticketTemplateList = this.$system.ticketTemplates.map((x) => {return { ...x, showBody: false };});
            }
            await this.checkCustomerIdsFromQuery();
            this.$loading.finish();
        });
    },
};
</script>
